import React from "react";

export function SectionLabel({ children, dark = false, className = "", testid }) {
  return (
    <span
      data-testid={testid}
      className={`section-pill ${dark ? "!bg-forest-500 !text-cream-100 !border-forest-400" : ""} ${className}`}
    >
      <span className="opacity-70">→</span> {children}
    </span>
  );
}

export function HighlightText({ children }) {
  return <span className="highlight-sage">{children}</span>;
}

export function ToolPill({ children }) {
  return (
    <span className="tool-pill">
      <span className="w-1.5 h-1.5 rounded-full bg-forest-500 inline-block" />
      {children}
    </span>
  );
}

// Two-column section heading: left big title (with serif italic), right description
export function SectionHeading({ label, title, italic, description, dark = false, center = false }) {
  return (
    <div className={`grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 mb-12 ${center ? "text-center" : ""}`}>
      <div className={`lg:col-span-7 ${center ? "lg:col-span-12" : ""}`} data-reveal>
        {label && (
          <div className="mb-5">
            <SectionLabel dark={dark}>{label}</SectionLabel>
          </div>
        )}
        <h2 className={`font-display font-extrabold tracking-tight ${dark ? "text-cream-100" : "text-forest-600"} text-4xl md:text-5xl lg:text-6xl leading-[1.05]`}>
          {title}
          {italic && (
            <>
              {" "}
              <span className="font-serif-italic font-normal">{italic}</span>
            </>
          )}
        </h2>
      </div>
      {description && !center && (
        <div className="lg:col-span-5 lg:pt-12" data-reveal>
          <p className={`text-base leading-relaxed ${dark ? "text-cream-100/70" : "text-forest-400"}`}>
            {description}
          </p>
        </div>
      )}
    </div>
  );
}
